let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("a31RA")).then(() => parcelRequire('cME1J'));